/**
 * Toast 和通知消息处理模块
 *
 * 职责：
 * 1. 处理通用 Toast 消息（TOAST_COMMON）
 * 2. 处理统一通知消息（COMMON_NOTICE）
 */

import { showToast } from 'vant'

/**
 * 处理 Toast 消息
 * @param {Object} event - EventBus 事件对象
 * @param {Object[]} event.data - IMManager 派发的消息数组（通常只有一条）
 */
export function handleToast(event) {
  const { data: messages } = event
  if (!Array.isArray(messages) || messages.length === 0) return

  // Toast 消息通常只有一条，取第一条
  const message = messages[0]
  if (message?.content) {
    showToast(message.content)
  }
}

/**
 * 处理统一通知消息
 * @param {Object} event - EventBus 事件对象
 * @param {Object[]} event.data - IMManager 派发的消息数组（通常只有一条）
 */
export function handleNotice(event) {
  const { data: messages } = event
  if (!Array.isArray(messages) || messages.length === 0) return

  // 统一通知通常只有一条，取第一条
  const message = messages[0]
  const content = message?.msg_content?.content_tips
  if (content) {
    showToast({
      message: content,
      duration: message.duration || 2000,
    })
  } else {
    // console.error('[Notifications] handleNotice: content is empty')
  }
}

// 暴露到 window 对象用于调试（保留原有行为）
if (typeof window !== 'undefined') {
  window.handleNotice = handleNotice
}
